import { useState } from "react";
import { throwResponseError } from "../../../utils/api-error-utils";
import { getAuthParams } from "../../../utils/pacto-rebates-utils";
import {
	formatHolidayPayload,
	formatHolidayResponse,
	validateHolidayPayload
} from "../../utils/holiday-utils";
import { hasValidationErrors } from "../../../utils/validation-utils";

export function useHolidayNew() {
	const [holiday, setHoliday] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const validateHoliday = values => {
		const errors = validateHolidayPayload(values);

		return {
			ok: !hasValidationErrors(errors),
			errors
		};
	};

	async function createHoliday(values) {
		const validation = validateHoliday(values);

		if (!validation.ok) {
			return {
				ok: false,
				reason: "validation",
				errors: validation.errors
			};
		}

		try {
			setLoading(true);
			setError(null);

			const { accessToken, clientId } = getAuthParams();
			const payload = formatHolidayPayload(values);

			const response = await fetch(
				process.env.REACT_APP_ESSILOR_API +
					"pacto-rebates-admin/v1/feriados",
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						"access_token": accessToken,
						"client_id": clientId
					},
					body: JSON.stringify(payload)
				}
			);

			if (!response.ok) {
				await throwResponseError(response, "Erro ao cadastrar feriado.");
			}

			const data = await response.json();
			const formattedHoliday = formatHolidayResponse(data);

			setHoliday(formattedHoliday);

			return {
				ok: true,
				holiday: formattedHoliday
			};
		} catch (requestError) {
			const errorMessage = requestError.message || "Erro ao cadastrar feriado.";

			setHoliday(null);
			setError(errorMessage);

			return {
				ok: false,
				reason: "request",
				error: errorMessage
			};
		} finally {
			setLoading(false);
		}
	}

	return {
		holiday,
		loading,
		error,
		validateHoliday,
		createHoliday
	};
}